import React from 'react';
import {
  Container,
  Row,
  Col,
  Button,
} from 'reactstrap';
import appSyncClient from '../../../appsync/client';
import deleteSocialProvider from '../../../appsync/mutations/DeleteSocialProvider';
import Text from '../../Text';

import SITE_PATHS from '../../../config/sitePaths';

import './style.scss';

const handleRemoveButtonClick = (scoringRequest, connectionName, history) => {
  appSyncClient.mutate({
    mutation: deleteSocialProvider(scoringRequest.requestId, connectionName),
  })
    .then(() => history.push(SITE_PATHS.SOCIAL_CONNECTORS, { scoringRequest }))
    .catch(console.error); // eslint-disable-line no-console
};

export default function ConnectedSocialProfile(props) {
  const {
    scoringRequest,
    data,
    providerName,
  } = props.location.state;

  const {
    connectionName,
    name,
    email,
    photoUrl,
    createdAt,
  } = data;

  const imageSource = photoUrl === 'undefined' ? props.location.state.imageSource : photoUrl;

  return (
    <Container className="connected-social-provider">
      <Row>
        <Col className="connected-social-icon-row">
          <img alt="Your profile logo" src={imageSource} />
          <img
            alt="Trust Science T logo"
            src="/images/ts-logo.png"
            srcSet="/images/ts-logo@2x.png 2x, /images/ts-logo@3x.png 3x"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <h5>
            <Text value="You have connected to" />
            &nbsp;
            {providerName}
          </h5>
        </Col>
      </Row>
      {name !== 'undefined'
      && (
        <Row className="profile-details-grid">
          <Col className="profile-detail-left-column">
            <Text value="Name" />
              &nbsp;
          </Col>
          <Col>{name}</Col>
        </Row>
      )}
      {email !== 'undefined'
      && (
        <Row className="profile-details-grid">
          <Col className="profile-detail-left-column">
            <Text value="Email" />
            &nbsp;
          </Col>
          <Col>{email}</Col>
        </Row>
      )}
      {createdAt !== 'undefined'
        && (
          <Row className="profile-details-grid">
            <Col className="profile-detail-left-column">
              <Text value="ConnectionDate" />
              &nbsp;
            </Col>
            <Col>{new Date(createdAt).toString().substring(15, -1)}</Col>
          </Row>
        )}
      <Row className="button-row">
        <Col>
          <Button
            color="success"
            onClick={props.history.goBack}
          >
            <Text value="Go Back" />
          </Button>
        </Col>
      </Row>
      <Row className="button-row">
        <Col>
          <Button
            color="danger"
            onClick={
              () => handleRemoveButtonClick(
                scoringRequest,
                connectionName,
                props.history,
              )
            }
          >
            <Text value="Remove This Connection" />
          </Button>
        </Col>
      </Row>
    </Container>
  );
}
